export const NOOR = {
  // Age gate
  ageGate: "age-gate-modal",
  ageGateYes: "age-gate-yes",
  ageGateNo: "age-gate-no",

  // Edition counter (global top bar)
  editionCounter: "edition-counter",
  editionTotal: "edition-total",
  editionRemaining: "edition-remaining",

  // Nav
  navLogo: "nav-logo",
  navHeritage: "nav-heritage",
  navCraft: "nav-craft",
  navTasting: "nav-tasting",
  navGallery: "nav-gallery",
  navReserve: "nav-reserve",
  navContact: "nav-contact",
  navCtaReserve: "nav-cta-reserve",
  navInnerCircle: "nav-inner-circle",
  navManifesto: "nav-manifesto",

  // Hero
  heroSection: "hero-section",
  heroBottle: "hero-bottle-image",
  heroCtaDiscover: "hero-cta-discover",
  heroCtaReserve: "hero-cta-reserve",

  // Heritage
  heritageSection: "heritage-section",

  // Craft
  craftSection: "craft-section",
  craftBoxImage: "craft-box-image",

  // Tasting
  tastingSection: "tasting-section",

  // Gallery
  gallerySection: "gallery-section",
  galleryItemHero: "gallery-item-hero",
  galleryItemBox: "gallery-item-box",
  galleryItemDisplay: "gallery-item-display",
  galleryItemSealed: "gallery-item-sealed",

  // Reserve / Newsletter
  reserveSection: "reserve-section",
  reserveEmailInput: "reserve-email-input",
  reserveSubmitBtn: "reserve-submit-btn",
  reserveSuccess: "reserve-success-message",

  // Inquiry / Contact
  contactSection: "contact-section",
  inquiryNameInput: "inquiry-name-input",
  inquiryEmailInput: "inquiry-email-input",
  inquiryMessageInput: "inquiry-message-input",
  inquiryTypeSelect: "inquiry-type-select",
  inquirySubmitBtn: "inquiry-submit-btn",
  inquirySuccess: "inquiry-success-message",

  // Manifesto page
  manifestoPage: "manifesto-page",
  manifestoBody: "manifesto-body",
  manifestoCtaCircle: "manifesto-cta-circle",
  manifestoCtaHome: "manifesto-cta-home",

  // Waiting Room
  waitingRoom: "waiting-room",
  waitingPosition: "waiting-position",

  // Inner Circle page
  innerCirclePage: "inner-circle-page",
  innerCircleCodeInput: "inner-circle-code-input",
  innerCircleCodeSubmit: "inner-circle-code-submit",
  innerCircleCodeError: "inner-circle-code-error",
  innerCircleApplyFullName: "inner-circle-apply-full-name",
  innerCircleApplyEmail: "inner-circle-apply-email",
  innerCircleApplyCity: "inner-circle-apply-city",
  innerCircleApplyIntro: "inner-circle-apply-intro",
  innerCircleApplyReferral: "inner-circle-apply-referral",
  innerCircleApplySubmit: "inner-circle-apply-submit",
  innerCircleApplySuccess: "inner-circle-apply-success",

  // Footer
  footerSection: "footer-section",
  footerDisclaimer: "footer-disclaimer",

  // Coming Soon (pre-launch landing)
  comingSoonPage: "coming-soon-page",
  comingSoonCountdown: "coming-soon-countdown",
  comingSoonWaitlist: "coming-soon-waitlist",
  comingSoonEmailInput: "coming-soon-email-input",
  comingSoonSubmit: "coming-soon-submit",
};
